import React from 'react';

const TrafficCard = ({data}) => {
  let {domain, firstTraffic, traffic, totalTraffic, fraud, totalFraud} = data;

  let date;

  if (firstTraffic) {
    date = new Date(firstTraffic * 1000).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  }
  else {
    date = '-';
  }

  return (
    <div style={{
           border: '1px solid gray',
           margin: '10px',
         }}>
      <div style={{display: 'flex',
                   flexDirection: 'row',
                   alignItems: 'center',
                   marginTop: '10px',
                   gap: '10px',
                   padding: '10px',
                  }}>
        <span style={{fontSize: '18px',
                      fontWeight: 'bold',
                      color: 'gray',
                     }}>
          Domain
        </span>
        <span>
          {domain}
        </span>
      </div>

      <div style={{display: 'flex',
                   flexDirection: 'row',
                   alignItems: 'center',
                   marginTop: '10px',
                   gap: '10px',
                   padding: '10px',
                  }}>
        <span style={{fontSize: '18px',
                      fontWeight: 'bold',
                      color: 'gray',
                     }}>
          First Traffic
        </span>
        <span>
          {date}
        </span>
      </div>

      <div style={{display: 'flex',
                   flexDirection: 'row',
                   alignItems: 'center',
                   marginTop: '10px',
                   gap: '10px',
                   padding: '10px',
                  }}>
        <span style={{fontSize: '18px',
                      fontWeight: 'bold',
                      color: 'gray',
                     }}>
          Total Traffic
        </span>
        <span>
          {totalTraffic}
        </span>
      </div>

      <div style={{display: 'flex',
                   flexDirection: 'column',
                   marginTop: '10px',
                   gap: '10px',
                   border: '1px solid gray',
                   padding: '10px',
                  }}>
        <span style={{fontSize: '18px',
                      fontWeight: 'bold',
                      color: 'gray',
                     }}>
          Traffic
        </span>
        <div style={{display: 'flex',
                     flexDirection: 'column',
                     width: '100%',
                    }}>
          {traffic.map((item, index) => (
            <div key={index}
                 style={{display: 'flex',
                         width: '100%',
                         justifyContent: 'space-between',
                         gap: '5px'}}>
              <span>{item.utm_source}</span>
              <span>{item.count}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{display: 'flex',
                   flexDirection: 'row',
                   alignItems: 'center',
                   marginTop: '10px',
                   gap: '10px',
                   padding: '10px',
                  }}>
        <span style={{fontSize: '18px',
                      fontWeight: 'bold',
                      color: 'gray',
                     }}>
          Total Fraud
        </span>
        <span>
          {totalFraud}
        </span>
      </div>

      <div style={{display: 'flex',
                   flexDirection: 'column',
                   marginTop: '10px',
                   gap: '10px',
                   border: '1px solid gray',
                   padding: '10px',
                  }}>
        <span style={{fontSize: '18px',
                      fontWeight: 'bold',
                      color: 'gray',
                     }}>
          Fraud
        </span>
        <div style={{display: 'flex',
                     flexDirection: 'column',
                     width: '100%',
                    }}>
          {fraud.map((item, index) => (
            <div key={index}
                 style={{display: 'flex',
                         width: '100%',
                         justifyContent: 'space-between',
                         gap: '5px'}}>
              <span>{item.utm_source}</span>
              <span>{item.count} ({item.goodCount})</span>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}

export default TrafficCard;
